'use client';

import { Box, Tooltip } from '@mui/material';
import type { IngestionPipelineStatus } from '@repo/api-gw-sdk';
import React from 'react';

interface IngestionPipelineStatusConfig {
  title: string;
  iconColor: string;
  backgroundColor: string;
  icon: string;
}

const ingestionPipelineStatusConfig: Record<
  string,
  IngestionPipelineStatusConfig
> = {
  CREATING: {
    title: 'Creating',
    iconColor: 'var(--mui-palette-info-main)',
    backgroundColor: 'var(--mui-palette-info-opacity)',
    icon: 'material-symbols-avg-pace-rounded',
  },
  CREATE_FAILED: {
    title: 'Create Failed',
    iconColor: 'var(--mui-palette-error-main)',
    backgroundColor: 'var(--mui-palette-error-opacity)',
    icon: 'material-symbols-disc-full-outline-rounded',
  },
  STOPPED: {
    title: 'Stopped',
    iconColor: 'var(--mui-palette-custom-GREY-01)',
    backgroundColor: 'var(--mui-palette-custom-GREY-OPACITY)',
    icon: 'material-symbols-do-not-disturb-on-outline-rounded',
  },
  STARTING: {
    title: 'Starting',
    iconColor: 'var(--mui-palette-info-main)',
    backgroundColor: 'var(--mui-palette-info-opacity)',
    icon: 'material-symbols-avg-pace-rounded',
  },
  STARTED: {
    title: 'Started',
    iconColor: 'var(--mui-palette-success-main)',
    backgroundColor: 'var(--mui-palette-success-opacity)',
    icon: 'material-symbols-check-circle-outline-rounded',
  },
  STOPPING: {
    title: 'Stopping',
    iconColor: 'var(--mui-palette-info-main)',
    backgroundColor: 'var(--mui-palette-info-opacity)',
    icon: 'material-symbols-avg-pace-rounded',
  },
  DELETING: {
    title: 'Deleting',
    iconColor: 'var(--mui-palette-info-main)',
    backgroundColor: 'var(--mui-palette-info-opacity)',
    icon: 'material-symbols-avg-pace-rounded',
  },
};

export const IngestionPipelineStatusCell = React.forwardRef<
  HTMLSpanElement,
  {
    status: IngestionPipelineStatus;
    hideTooltip?: boolean;
  }
>(({ status, hideTooltip }, ref) => {
  const config = ingestionPipelineStatusConfig[status];
  if (!config) {
    return null;
  }

  return (
    <Tooltip title={hideTooltip ? undefined : config.title}>
      <Box
        ref={ref}
        component='span'
        className='rounded-full inline-flex p-[2px]'
        sx={{
          background: config.backgroundColor,
          '& i': {
            background: config.iconColor,
          },
        }}
      >
        <i className={`${config.icon} h-[20px] w-[20px]`} />
      </Box>
    </Tooltip>
  );
});

IngestionPipelineStatusCell.displayName = 'IngestionPipelineStatusCell';
